export default __webpack_public_path__ + "static/media/laravel.57afce85.svg";